
//Local 
// export class Constants {
//     Email = "email";
//     Phone = "phone";
//     AuthPortNumber = "9601/";
//     ManageUserPortNumber= "9601/";
//     logOutTime: number = 300;
//     logoutNotificationTime: number = 2000;
//     PermissionPortNumber = "9601/"
//     RolePortNumber = "9601/";
//     ManageOrganizationPortNumber= "9601/"
//     ManageModulePortNumber = "9601/"
//     SettingsPortNumber = "9602/"
//     ManageDocumentPortNumber = "9023/"  //--not used
//     ManageContactsportNumber = "9019/"  // --not used
//     ManageCoreportNumber = "9602/"
//     CustomizedGridComponentPortNumber = "9604/"
//     ManageTranscationportNumber = "9603/" 
//     Chat= "9605/";
//     Edit =  "Edit Permission";
//     Add = "Add Permission";
//     Delete = "Delete Permission";
//     routeArray=[
//         {rolesRoute: "roles"},
//         {userRoute : "users"},
//         {permissionRoute : "permissions"},
//         {organizationRoute : "organization"},
//         {moduleMatserRoute: "moduleMaster"}
//     ]
    
 
//     DropDownField = "Dropdown";
//     CheckboxField = "Checkbox";
//     Image = "Image";
//     URL ="URL";
//     TextArea = "Textarea";
//     Number= "Number";
//     MultiSelect = "MultiSelect";
//     Date = "Date";
//     Currency = "Currency";
//     RadioButton = "RadioButton";
//     TextBox = "Textbox";
//     Address = "Address";
// }


  //  // - Staging
  // export class Constants {
  //   AuthPortNumber = "https://ecmadminapp-staging.azurewebsites.net/";
  //   ManageUserPortNumber= "https://ecmadminapp-staging.azurewebsites.net/";
  //   PermissionPortNumber = "https://ecmadminapp-staging.azurewebsites.net/";
  //   RolePortNumber = "https://ecmadminapp-staging.azurewebsites.net/";
  //   ManageOrganizationPortNumber= "https://ecmadminapp-staging.azurewebsites.net/";
  //   ManageModulePortNumber = "https://ecmadminapp-staging.azurewebsites.net/";

  //   SettingsPortNumber = "https://ecmsetting-staging.azurewebsites.net/";
  //   ManageCoreportNumber = "https://ecmsetting-staging.azurewebsites.net/";

  //   ManageDocumentPortNumber = "9023";//--Not used
  //   ManageContactsportNumber = "9019/";// -- Not used

  //   CustomizedGridComponentPortNumber = "https://appmanagecustomizedgridcomponentprod-staging.azurewebsites.net/";
  //   ManageTranscationportNumber = "https://appmanagetransactionprod-staging.azurewebsites.net/";
  //   ManageTask = "https://taskschedulingapi-statging.azurewebsites.net/";
  //   Chat= "https://appservicechatprod-staging.azurewebsites.net/"; 
  //   ImportExport="https://importprocessor-staging.azurewebsites.net/";
  //   Edit =  "Edit Permission";
  //   Add = "Add Permission";
  //   Delete = "Delete Permission";
  //   routeArray=[
  //       {rolesRoute: "roles"},
  //       {userRoute : "users"},
  //       {permissionRoute : "permissions"},
  //       {organizationRoute : "organization"},
  //       {moduleMatserRoute: "moduleMaster"}
  //   ]
  //   envProd=false;
  //   Email = "email";
  //   Phone = "phone";
  //   logOutTime: number = 300;
  //  // logoutNotificationTime: number = 3000;
  //   logoutNotificationTime: number = 19000;//1500;
  //   DropDownField = "Dropdown";
  //   CheckboxField = "Checkbox";
  //   Image = "Image";
  //   URL ="URL";
  //   TextArea = "Textarea";
  //   Number= "Number";
  //   MultiSelect = "MultiSelect";
  //   Date = "Date";
  //   Currency = "Currency";
  //   RadioButton = "RadioButton";
  //   TextBox = "Textbox";
  //   Address = "Address";
  // } 

  
 //Prod

 export class Constants {
  AuthPortNumber = "https://ecmadminapp.azurewebsites.net/";
  ManageUserPortNumber= "https://ecmadminapp.azurewebsites.net/";
  PermissionPortNumber = "https://ecmadminapp.azurewebsites.net/";
  RolePortNumber = "https://ecmadminapp.azurewebsites.net/";
  ManageOrganizationPortNumber= "https://ecmadminapp.azurewebsites.net/";
  ManageModulePortNumber = "https://ecmadminapp.azurewebsites.net/";

  SettingsPortNumber = "https://ecmsetting.azurewebsites.net/";
  ManageCoreportNumber = "https://ecmsetting.azurewebsites.net/";

  ManageDocumentPortNumber = "9023";//--Not used
  ManageContactsportNumber = "9019/";// -- Not used

  CustomizedGridComponentPortNumber = "https://appmanagecustomizedgridcomponentprod.azurewebsites.net/";
  ManageTranscationportNumber = "https://appmanagetransactionprod.azurewebsites.net/";
  ManageTask = "https://taskschedulingapi.azurewebsites.net/";
  Chat= "https://appservicechatprod.azurewebsites.net/";
  ImportExport="https://importprocessor.azurewebsites.net/";
  Edit =  "Edit Permission";
  Add = "Add Permission";
  Delete = "Delete Permission";
  routeArray=[
      {rolesRoute: "roles"},
      {userRoute : "users"},
      {permissionRoute : "permissions"},
      {organizationRoute : "organization"},
      {moduleMatserRoute: "moduleMaster"}
  ] 
  envProd=true;
  Email = "email";
  Phone = "phone";
  logOutTime: number = 300;
  logoutNotificationTime: number = 19000;//1500;
  DropDownField = "Dropdown";
  CheckboxField = "Checkbox";
  Image = "Image";
  URL ="URL";
  TextArea = "Textarea";
  Number= "Number";
  MultiSelect = "MultiSelect";
  Date = "Date";
  Currency = "Currency";
  RadioButton = "RadioButton";
  TextBox = "Textbox";
  Address = "Address";
}


